import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const App = () => {
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (token) {
            try {
                const decoded = jwtDecode(token); // Token dekodieren
                if (decoded.workspace_id === 100833) {
                    // Production
                    window.location.href =
                        'https://frontend100833.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 200137) {
                    // Production
                    window.location.href =
                        'https://frontend200137.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 199213) {
                    // Production
                    window.location.href =
                        'https://frontend199213.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 179211) {
                    // Production
                    window.location.href =
                        'https://frontend179211.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 211663) {
                    // Production
                    window.location.href =
                        'https://frontend211663.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 178869) {
                    // Production
                    window.location.href =
                        'https://frontend178869.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 143287) {
                    // Production
                    window.location.href =
                        'https://frontend143287.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 255543) {
                    // Production
                    window.location.href =
                        'https://frontend255543.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 266613) {
                    // Production
                    window.location.href =
                        'https://frontend266613.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 243521) {
                    // Production / Ex customer
                    // window.location.href =
                    // 'https://frontend243521.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 244691) {
                    // Production
                    window.location.href =
                        'https://frontend244691.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 274895) {
                    // Production
                    window.location.href =
                        'https://frontend274895.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id === 293735) {
                    // Production
                    window.location.href =
                        'https://frontend293735.matemy.day/auth/login?token=' + token;
                } else if (decoded.workspace_id > 293800) {
                    // Production
                    window.location.href = `https://frontend${decoded.workspace_id}.matemy.day/auth/login?token=${token}`;
                } else {
                    setErrorMessage(
                        'Zugriff verweigert: Dieser Service ist für Sie nicht verfügbar.'
                    );
                }
            } catch (error) {
                console.error('Ungültiges Token', error);
                setErrorMessage('Fehler: Das Token ist ungültig oder beschädigt.');
            }
        } else {
            setErrorMessage('Fehler: Kein Token gefunden.');
        }
    }, [location]);

    return (
        <div className="error-container">
            <h1>{errorMessage}</h1>
        </div>
    );
};

export default App;
